import { toDate, utcToZonedTime } from 'date-fns-tz';
import { parse } from 'date-fns'

export const getISOStringByTimezone = (date, time, tz) => {
  const intlTime = parse(time, 'h:mmaa', new Date())
  const hh = intlTime.getHours()
  const intlDateTime = `${date}T${hh < 10 ? `0${hh}` : hh}:00:00`
  const inUTC = toDate(intlDateTime, { timeZone: tz })
  return inUTC.toISOString()
}